module.exports = __webpack_public_path__ + "static/media/headerBanner.0379c5e8.jpg";